import createReducer from 'common/redux/utils/createReducer';
import {
  INITIAL_DATA_LOADED,
  NEWS_TARGET_MODAL_OPENED,
  NEWS_TARGET_MODAL_CLOSED,
  NEWS_TARGET_ADDED,
  NEWS_TARGET_REMOVED,
  NEWS_TARGET_CLEAR,
} from '../actions/index';
import { Map, Seq } from 'immutable';

const initialState = {
  targets: Map(),
  editable: false,
  modalOpened: false,
};

export const newsReducer = createReducer(initialState, {
  [INITIAL_DATA_LOADED](state, { datas }) {
    const editable = datas == null;
    const targets = Seq(datas).map(d => [datas.indexOf(d), d]);
    return {
      ...state,
      targets: Map(targets),
      editable: editable,
    };
  },
  [NEWS_TARGET_MODAL_OPENED](state, action) {
    return {
      ...state,
      modalOpened: true,
    };
  },
  [NEWS_TARGET_MODAL_CLOSED](state, action) {
    return {
      ...state,
      modalOpened: false,
    };
  },
  [NEWS_TARGET_ADDED](state, { target }) {
    return {
      ...state,
      targets: state.targets.set(state.targets.size + 1, target),
      modalOpened: false,
    };
  },
  [NEWS_TARGET_REMOVED](state, { pos }) {
    return {
      ...state,
      targets: state.targets.delete(pos),
    };
  },
  [NEWS_TARGET_CLEAR](state, action) {
    return {
      ...state,
      targets: Map(),
    };
  },
});

export const getTargets = state => {
  return state.news.targets;
};

export const isEditable = state => {
  return state.news.editable;
};

export const isModalOpened = state => {
  return state.news.modalOpened;
};



// WEBPACK FOOTER //
// ./src/modules/news/reducers/index.js